export const JapaneseLabels: Record<string, string> = {

  // customer list table header label
  'personalId': "個人ID",
  'customerName': "顧客名",
  'telePhoneNumber': "電話番号",
  'dateOfBirth': "生年月日",
  'numberOfRegister': "レントゲン登録件数",
  'action': "アクション",

  // x-ray list table header label
  'applicationNumber': "申込番号",
  'applicationDateTime': "申込日時",
  'customerNames': "顧客名（管理番号）",
  'status': "レントゲン対象",
  'xRayType': "レントゲン種別",
  'desiredNumber': "希望枚数",
  'conversionStatus': "変換ステータス",


  //basic setting page japanese labels
  'basicSetting': "基本設定",
  'emailAddress': "メールアドレス",
  'newPassword': "新しいパスワード",
  'confirmPassword': "パスワード（確認）",
  'currentPassword': "現在のパスワード",
  'registerButton': "登録する",

  //support setting japanese labels
  'supportSetting': "サポート設定",
  'terms_of_serve': "利用規約",
  'display_terms_of_serve': "アプリの設定「利用規約」に表示されます。",
  'privacy_policy_settings': "プライバシーポリシー設定",
  'display_privacy_policy_settings': "アプリの設定「プライバシーポリシー」に表示されます。",
  'information': "特定商取引法・資金決済法に基づく表記",
  'display_information': "アプリの設定「特定商取引法・資金決済法に基づく表記」に表示されます。",
  'contact_settings': "お問い合わせ設定",
  'display_contact_settings': "アプリの設定「お問い合わせ」のURLを設定してください。",
  'submit_button': "保存する",


  //x-ray new page japanese labels
  'xRayRegistration': "レントゲン登録",
  'customerInformation': "顧客情報",
  'customerNameShow': "顧客名（個人ID）",
  'registerPhoneNumber': "登録電話番号",
  'dateOfBirthShow': "生年月日",
  'emailAddressShow': "メールアドレス",
  'userWhoResisterXRay': "▼レントゲンファイルを登録するユーザー",
  'selectUser': "ユーザーを選択",
  "hospitalName": "▼撮影医療機関名",
  'dcomFileUpload': "▼DCMファイルを1件ずつ登録してください（最大5件まで）",
  'uploadFile': "▼アップロードされたファイル",
  'selectFile': "ファイルを選択",
  'registerXRayButton': "レントゲン登録",
  'backToList': "一覧に戻る",

  //user list page japanese labels



};

export const fieldKeys: Record<string, string> = {
  "registration_number": '登録番号',
  "company_name": '社名',
  "problem": '不具合内容',
  "date_of_first_registration": '初回登録日',
  "updated_at": '更新日',
  "pull_down_name_degree": '程度',
};


export const ErrorTexts: Record<string, string> = {


  // basic setting page  error texts

  'newPasswordLength': "パスワードは6文字以上で入力してください",
  'newPasswordRequired': "新しいパスワードを入力してください",
  'confirmPasswordMatch': "パスワードが一致しません",
  'currentPasswordRequired': "現在のパスワードを入力してください",

};